(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-icon-columns"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!document.querySelector('[data-custom-icon-columns][data-has-lucide="true"]')) {
      return;
    }

    const loadLucide = () => {
      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        return Promise.resolve(window.lucide);
      }

      if (window.__customIconColumnsLucidePromise) {
        return window.__customIconColumnsLucidePromise;
      }

      window.__customIconColumnsLucidePromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/lucide@latest';
        script.async = true;
        script.onload = () => resolve(window.lucide);
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.__customIconColumnsLucidePromise;
    };

    loadLucide()
      .then((lucide) => {
        if (lucide && typeof lucide.createIcons === 'function') {
          lucide.createIcons();
        }
      })
      .catch(() => {
        /* no-op */
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-instagram-reels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    for (const section of document.querySelectorAll('.custom-instagram-reels')) {
      if (section.dataset.reelsInitialized) continue;
      section.dataset.reelsInitialized = 'true';

      const cards = section.querySelectorAll('.custom-instagram-reels__card');

      const getVideo = (card) => card.querySelector('.custom-instagram-reels__video');
      const loadVideo = (card) => {
        const media = card.querySelector('deferred-media');
        if (!media || media.hasAttribute('loaded')) return getVideo(card);
        media.loadContent(false);
        return getVideo(card);
      };
      // A card "should" be playing while it's on screen (or being hovered/focused)
      // and the visitor hasn't explicitly paused it. Any other card's first load
      // calls the theme-wide window.pauseAllMedia(), which stops every <video> on
      // the page — the "pause" listener below uses this to self-heal from that.
      const shouldAutoplay = (card) =>
        !reduceMotion && card.dataset.userPaused !== 'true' && card.dataset.inView === 'true';
      const playVideo = (card) => {
        const video = loadVideo(card);
        if (!video) return;
        video.play().catch(() => {});
      };
      const pauseVideo = (card) => getVideo(card)?.pause();

      for (const card of cards) {
        const toggle = card.querySelector('[data-reel-toggle]');
        const soundToggle = card.querySelector('[data-reel-sound-toggle]');
        if (toggle) {
          toggle.addEventListener('click', () => {
            const video = loadVideo(card);
            if (!video) return;
            if (video.paused) {
              card.dataset.userPaused = 'false';
              video.play().catch(() => {});
            } else {
              card.dataset.userPaused = 'true';
              video.pause();
            }
          });
        }
        if (soundToggle) {
          soundToggle.addEventListener('click', () => {
            const video = loadVideo(card);
            if (!video) return;
            video.muted = !video.muted;
            if (!video.muted) video.play().catch(() => {});
          });
        }

        card.addEventListener('play', () => {
          if (!toggle) return;
          toggle.setAttribute('aria-label', 'Pausar reel');
          toggle.setAttribute('aria-pressed', 'true');
        }, true);
        card.addEventListener('pause', () => {
          if (toggle) {
            toggle.setAttribute('aria-label', 'Reproducir reel');
            toggle.setAttribute('aria-pressed', 'false');
          }
          if (shouldAutoplay(card)) requestAnimationFrame(() => playVideo(card));
        }, true);
        card.addEventListener('volumechange', (event) => {
          if (!soundToggle) return;
          const isMuted = event.target.muted || event.target.volume === 0;
          soundToggle.setAttribute('aria-label', isMuted ? 'Activar sonido' : 'Silenciar sonido');
          soundToggle.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
        }, true);

        card.addEventListener('mouseenter', () => {
          if (!reduceMotion && card.dataset.userPaused !== 'true') playVideo(card);
        });
        card.addEventListener('mouseleave', () => {
          if (card.dataset.inView !== 'true') pauseVideo(card);
        });
        card.addEventListener('focusin', () => {
          if (!reduceMotion && card.dataset.userPaused !== 'true') playVideo(card);
        });
        card.addEventListener('focusout', () => {
          if (card.dataset.inView !== 'true') pauseVideo(card);
        });
      }

      if (!cards.length) continue;

      const viewObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const card = entry.target;
            card.dataset.inView = entry.isIntersecting ? 'true' : 'false';
            if (shouldAutoplay(card)) {
              playVideo(card);
            } else if (!entry.isIntersecting) {
              pauseVideo(card);
            }
          }
        },
        { threshold: 0.5 }
      );
      cards.forEach((card) => viewObserver.observe(card));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
